import { CssBaseline } from "@mui/material";
import "./index.scss";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import useTheme from "./modules/common/hooks/use-theme";
import { ThemeProvider } from "./modules/common/contexts/theme-context";
import createTheme from "./modules/common/theme";
import { LoginPage } from "./modules/login/LoginPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./modules/dashboard";
import AuthWrapper from "./modules/wrapper/auth-wrapper";
import { ToastContainer } from "react-toastify";
// import { ThemeProvider } from "modules/common/contexts/theme-context";

//
function App() {
  const { theme } = useTheme();
  return (
    <ThemeProvider>
      <MuiThemeProvider theme={createTheme(theme)}>
        <CssBaseline />
        <ToastContainer position="top-right" theme="colored" />
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <AuthWrapper>
                  <Dashboard />
                </AuthWrapper>
              }
            />
          </Routes>
        </Router>
      </MuiThemeProvider>
    </ThemeProvider>
  );
}
//
export default App;
